import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-blue-primary rounded-md mb-8"
}
const _hoisted_2 = { class: "text-center p-3" }
const _hoisted_3 = { class: "text-center text-white text-sm" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Update token image.  ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add Image ")
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "form-group mb-4 text-center" }
const _hoisted_9 = { class: "form-group mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm mb-2 text-white" }, "Token Name", -1)
const _hoisted_11 = { class: "form-group mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm mb-2 text-white" }, "Token Symbol", -1)
const _hoisted_13 = { class: "form-group mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm mb-2 text-white" }, "Type of Token", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "IGT" }, "In-Game Token", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "LET" }, "Limited Edition Token", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "NFT" }, "Non-Fungible Token", -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "form-group mb-4"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm mb-2 text-white" }, "Token Divisibility", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", {
  value: 0,
  selected: ""
}, "0", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 2,
  class: "form-group mb-4"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm mb-2 text-white" }, "Circulation Supply", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text text-xs mt-1.5" }, [
  /*#__PURE__*/_createTextVNode("Remark: Number of digit for "),
  /*#__PURE__*/_createElementVNode("b", null, "Circulation Supply"),
  /*#__PURE__*/_createTextVNode(" depends on "),
  /*#__PURE__*/_createElementVNode("b", null, "Token Divisibility")
], -1)
const _hoisted_26 = { class: "form-group mb-4" }
const _hoisted_27 = { class: "text-sm mb-2 text-white" }
const _hoisted_28 = { class: "text-sm text-gray-text" }
const _hoisted_29 = {
  key: 3,
  class: "text-sm text-gray-text my-2"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://developers.xarcade.io/docs/Onboarding/testnet_token_creation%20copy",
  target: "_new",
  class: "text-blue-primary hover:underline duration-200 transition-all"
}, "guide", -1)
const _hoisted_32 = { class: "text-center mb-5 md:mb-12 mt-3" }
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SupplyInput = _resolveComponent("SupplyInput")!
  const _component_tokensConfirmCreateTokenModal = _resolveComponent("tokensConfirmCreateTokenModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isDisplayUploadTokenImageLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileInput.click())),
                class: "border border-blue-900 p-1 px-2 bg-blue-900 hover:bg-blue-800 transition-all duration-200 rounded-md"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-camera",
                  class: "text-white inline-block mr-2"
                }),
                _hoisted_5
              ]),
              _createElementVNode("input", {
                style: {"display":"none"},
                ref: "fileInput",
                type: "file",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                accept: ".png, .jpg, .jpeg"
              }, null, 544),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateTokenImage && _ctx.updateTokenImage(...args))),
                  disabled: !_ctx.$refs.fileInput,
                  class: "mr-3 bg-success-check disabled:bg-gray-600 text-white p-1 px-2 hover:bg-green-700 duration-200 transition-all rounded-md"
                }, "Confirm", 8, _hoisted_7),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revertTokenImage && _ctx.revertTokenImage(...args))),
                  class: "hover:underline"
                }, "Cancel")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "inline-block border-black-border relative border border-dotted rounded-3xl w-36 bottom-0 h-36 left-0 bg-cover bg-center bg-black-body",
        style: _normalizeStyle({ 'background-image': `url(${_ctx.previewImage})` })
      }, [
        _createElementVNode("button", {
          class: "bg-black-body p-2 rounded-lg absolute",
          style: {"bottom":"0px","left":"0"},
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayUploadTokenImageLabel = !_ctx.isDisplayUploadTokenImageLabel))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-camera",
            class: "text-gray-text text-xl"
          })
        ])
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control outline-none px-3 py-2 rounded-md text-white border-0 w-full bg-black-body",
        placeholder: "Token Name",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tokenName) = $event))
      }, null, 512), [
        [_vModelText, _ctx.tokenName]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        maxlength: "5",
        oninput: "this.value = this.value.toUpperCase()",
        class: "form-control outline-none px-3 py-2 rounded-md text-white border-0 w-full uppercase bg-black-body",
        placeholder: "Token Symbol",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tokenSymbol) = $event))
      }, null, 512), [
        [_vModelText, _ctx.tokenSymbol]
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _withDirectives(_createElementVNode("select", {
        class: "text-white px-2 py-2 border-0 rounded-md bg-black-body text-md w-full outline-none my-1",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedTokenType) = $event)),
        onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updateTokenType && _ctx.updateTokenType(...args)))
      }, _hoisted_18, 544), [
        [_vModelSelect, _ctx.selectedTokenType]
      ])
    ]),
    (_ctx.selectedTokenType == 'IGT')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("select", {
            class: "text-white px-2 py-2 border-0 rounded-md bg-black-body text-md w-full outline-none my-1",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedTokenDivisibility) = $event)),
            onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateSupply && _ctx.updateSupply(...args)))
          }, [
            _hoisted_21,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (number) => {
              return _createElementVNode("option", {
                value: number,
                key: number
              }, _toDisplayString(number), 9, _hoisted_22)
            }), 64))
          ], 544), [
            [_vModelSelect, _ctx.selectedTokenDivisibility]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedTokenType!='NFT')
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          _createVNode(_component_SupplyInput, {
            modelValue: _ctx.supply,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.supply) = $event)),
            type: "text",
            supplyPlaceholder: _ctx.supplyPlaceholder,
            decimal: _ctx.selectedTokenType=='IGT'?_ctx.selectedTokenDivisibility:0,
            maxValue: _ctx.maxValue
          }, null, 8, ["modelValue", "supplyPlaceholder", "decimal", "maxValue"]),
          _hoisted_25
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, "Assigned " + _toDisplayString(_ctx.network) + " Token ID", 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control outline-none px-3 py-2 rounded-md text-white border-0 w-full bg-black-border",
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.assetId) = $event)),
        disabled: ""
      }, null, 512), [
        [_vModelText, _ctx.assetId]
      ])
    ]),
    _createElementVNode("div", _hoisted_28, "You need to connect your Sirius " + _toDisplayString(_ctx.network) + " account first before create new token.", 1),
    (_ctx.network==_ctx.testnetLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-brands fa-android",
            class: "inline-block mr-2 text-white"
          }),
          _createElementVNode("a", {
            href: _ctx.assetUrl + 'blob/downloads/sirius-mobile-wallet-testnet.apk',
            class: "text-blue-primary hover:underline transition-all duration-200",
            target: "_new"
          }, "Download", 8, _hoisted_30),
          _createTextVNode(" Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet apk (v" + _toDisplayString(_ctx.testnet2ApkVersion) + ") and refer to the ", 1),
          _hoisted_31
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("button", {
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.createTokenQr())),
        disabled: _ctx.disableCreate,
        class: "btn btn-primary"
      }, "Create Token", 8, _hoisted_33)
    ]),
    _createVNode(_component_tokensConfirmCreateTokenModal, {
      networkLabel: _ctx.network,
      onCloseModel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isQRModalShow = false)),
      onConfirmedButtonPressed: _cache[15] || (_cache[15] = ($event: any) => (_ctx.createToken())),
      isQRModalShow: _ctx.isQRModalShow,
      previewImage: _ctx.previewImage,
      tokenName: _ctx.tokenName,
      tokenSymbol: _ctx.tokenSymbol,
      selectedTokenType: _ctx.selectedTokenType,
      supply: parseFloat(_ctx.supply),
      qr: _ctx.qr,
      showUploadingLoader: _ctx.showUploadingLoader,
      isDisabledModalConfirmSubmitButton: _ctx.isDisabledModalConfirmSubmitButton
    }, null, 8, ["networkLabel", "isQRModalShow", "previewImage", "tokenName", "tokenSymbol", "selectedTokenType", "supply", "qr", "showUploadingLoader", "isDisabledModalConfirmSubmitButton"])
  ]))
}